import { ChatFixture, tokenize } from './types';

/**
 * Journey 1 — voice-chat.
 *
 * The user "says" (via the mic transcription simulation):
 *   "What if AI could run your law firm?"
 *
 * Prest0n replies:
 *   "Let me show you." + a short framing sentence.
 */
export const chatVoiceFixture: ChatFixture = {
  id: 'chat-voice',
  userQuery: 'What if AI could run your law firm?',
  voiceReplyUrl: '/moonshot/audio/chat-voice-reply.mp3',
  steps: [
    'mic-listen',
    'transcribe',
    'assistant-thinking',
    'assistant-stream',
    'voice-playback',
  ],
  chunks: [
    { delta: '', delayMs: 200, event: 'thinking', data: { label: 'Assessing...' } },
    ...tokenize(
      'Let me show you. In the next thirty seconds I will research California wrongful-termination ' +
        'precedent, summarize a client intake packet, draft a demand letter, translate it into Spanish, ' +
        'and surface every integration your firm runs on — all from this one chat.',
      55,
    ),
  ],
};

export default chatVoiceFixture;
